import React, { useEffect } from "react";
import cx from "classnames";

import UniversalTipTap from "components/UniversalTipTap";

import { ReactComponent as Sendbutton } from "resources/icons/sendbutton.svg";

const CreateWithNovaAiModalFooter = (props) => {
  const {
    messageText,
    setMessageText,
    handleSend,
    editor,
    disableEditor,
    isAiResponseLoading,
  } = props;
  useEffect(() => {
    if (editor && messageText && editor?.isEmpty) {
      editor.commands.setContent(messageText);
    }
  }, [editor, messageText]);

  const baseText = editor?.getText()?.trim();

  const handleSendMessage = () => {
    const plainText = editor?.getText()?.trim();
    if (!editor || isAiResponseLoading) return;

    if (baseText && plainText.length > 0) {
      handleSend(plainText);
      setMessageText("");
      editor.commands.clearContent();
    }
  };

  const handleEditorUpdate = ({ editor }) => {
    const plainText = editor?.getHTML()?.trim();
    setMessageText(plainText);
  };

  const handleKeyPress = (e) => {
    if (!editor || isAiResponseLoading) return;
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (baseText) {
        handleSendMessage();
      }
    }
  };

  return (
    <div
      className={cx("nova-ai-modal-footer", {
        "nova-ai-editor-disabled": disableEditor,
      })}
    >
      <div
        className={cx({
          "nova-ai-editor-gradient-background": editor?.isFocused,
          "nova-ai-editor-border-wrapper": !editor?.isFocused,
        })}
      >
        <div className="nova-editor-wrapper">
          <UniversalTipTap
            editor={editor}
            isEditable={false}
            editorClass="nova-ai-editor"
            editorContainerClass="nova-ai-editor-container"
            onUpdate={handleEditorUpdate}
            onKeyDown={handleKeyPress}
            isNovaFooter={true}
          />
        </div>
      </div>
      <div className="editor-footer">
        <Sendbutton
          className={cx("cursor-pointer nova-messege-send-button", {
            "cursor-not-allowed disabled nova-send-disabled":
              !baseText || isAiResponseLoading,
          })}
          onClick={handleSendMessage}
        />
      </div>
      <div className="flex align-center fs-small fw-500 nova-ai-warning-message">
        Nova AI can make mistakes. Please double-check all answers.
      </div>
    </div>
  );
};

export default CreateWithNovaAiModalFooter;
